/** Conceptual domain icons — decorative, not product UI. */
export type DomainIconName =
  | "education"
  | "hr"
  | "finance"
  | "ops"
  | "mines"
  | "health"
  | "security"
  | "erp";

export function DomainIcon({
  name,
  className = "",
}: {
  name: DomainIconName;
  className?: string;
}) {
  const common = {
    className: `pep-home-icon ${className}`.trim(),
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true as const,
  };

  switch (name) {
    case "education":
      return (
        <svg {...common}>
          <path d="M3 10.5 12 5l9 5.5-9 5.5L3 10.5Z" />
          <path d="M7 13v4.5c0 .8 2.2 2 5 2s5-1.2 5-2V13" />
        </svg>
      );
    case "hr":
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="2.5" />
          <circle cx="16" cy="9" r="2" />
          <path d="M3.5 18c.6-2.8 2.8-4.2 5.5-4.2S14 15.2 14.5 18" />
          <path d="M14 14.2c1.4-.5 2.9-.3 4.2.7.8.6 1.3 1.5 1.5 2.6" />
        </svg>
      );
    case "finance":
      return (
        <svg {...common}>
          <path d="M4 19V9" />
          <path d="M10 19V5" />
          <path d="M16 19v-7" />
          <path d="M20 19H3" />
        </svg>
      );
    case "ops":
      return (
        <svg {...common}>
          <path d="M12 3.5 14.2 8l4.8.5-3.6 3.4.9 4.7L12 14.6 7.7 16.6l.9-4.7L5 8.5 9.8 8 12 3.5Z" />
        </svg>
      );
    case "mines":
      return (
        <svg {...common}>
          <path d="M4 18h16" />
          <path d="M7 18 10 8h4l3 10" />
          <path d="M10 12h4" />
        </svg>
      );
    case "health":
      return (
        <svg {...common}>
          <path d="M9 3.5h6v4h4v6h-4v4H9v-4H5V7.5h4V3.5Z" />
        </svg>
      );
    case "security":
      return (
        <svg {...common}>
          <path d="M12 3 19 6.5v5.2c0 4.2-2.9 7.8-7 9.3-4.1-1.5-7-5.1-7-9.3V6.5L12 3Z" />
          <path d="M9.5 12.2 11.2 14l3.5-3.8" />
        </svg>
      );
    case "erp":
      return (
        <svg {...common}>
          <rect x="3.5" y="4" width="17" height="16" rx="2" />
          <path d="M3.5 9h17" />
          <path d="M9 9v11" />
        </svg>
      );
    default:
      return null;
  }
}

export function DiffIcon({ name }: { name: "suite" | "local" | "modular" }) {
  const common = {
    className: "pep-home-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true as const,
  };
  if (name === "suite") {
    return (
      <svg {...common}>
        <rect x="3" y="4" width="7" height="7" rx="1.2" />
        <rect x="14" y="4" width="7" height="7" rx="1.2" />
        <rect x="3" y="13" width="7" height="7" rx="1.2" />
        <rect x="14" y="13" width="7" height="7" rx="1.2" />
      </svg>
    );
  }
  if (name === "local") {
    return (
      <svg {...common}>
        <path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10Z" />
        <circle cx="12" cy="11" r="2.2" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M8 4h8l3 4-7 12L5 8l3-4Z" />
      <path d="M8 8h8" />
    </svg>
  );
}
